export const reviewTargetId = (row) => {
  if (row?.review_id != null) return row.review_id;
  const type = row?.review_type;
  if (
    type === "course_msr" ||
    type === "paper_purchase" ||
    type === "worksheet_result" ||
    type === "mock_attempt"
  ) {
    return row?.id ?? null;
  }
  return null;
};

export const canViewReview = (row) => {
  if (row?.can_review === false) return false;
  if (row?.can_review === true) return true;
  return Boolean(row?.is_completed && reviewTargetId(row) != null);
};

export const reviewRowKey = (row) =>
  `${row?.review_type || row?.type || "course"}-${reviewTargetId(row) ?? row?.id ?? ""}`;

const REVIEW_KIND_BY_TYPE = {
  paper_purchase: "papers",
  mock_attempt: "mocks",
  worksheet_result: "worksheets",
  course_msr: "resources",
};

export const reviewKindFromRow = (row) =>
  REVIEW_KIND_BY_TYPE[row?.review_type] || "resources";

export const reviewPagePath = (buyerId, row) => {
  const id = reviewTargetId(row);
  if (!buyerId || id == null) return null;
  return `/tutor/students/${buyerId}/review/${reviewKindFromRow(row)}/${id}`;
};

export const reviewEndpoint = (buyerId, rowOrKind, reviewId) => {
  let kind;
  let id;

  if (typeof rowOrKind === "object" && rowOrKind !== null) {
    id = reviewTargetId(rowOrKind);
    kind = reviewKindFromRow(rowOrKind);
  } else {
    kind = rowOrKind;
    id = reviewId;
  }

  switch (kind) {
    case "papers":
      return `tutor/students/${buyerId}/purchases/papers/${id}/review`;
    case "mocks":
      return `tutor/students/${buyerId}/purchases/mocks/${id}/review`;
    case "worksheets":
      return `tutor/students/${buyerId}/worksheets/${id}/review`;
    default:
      return `tutor/students/${buyerId}/resources/${id}/review`;
  }
};
